<template>
    <div class="text-xs max-w-[200px]">
        <div class="font-semibold" data-test="verification-line">{{ verificationDetail }}</div>
        <div v-if="props.entityType" class="text-slate-500" data-test="entity-line">
            {{ entityTypeLabels[props.entityType] }}
        </div>
        <div v-if="props.vettingClass" class="text-slate-500" data-test="vetting-line">{{ vettingDetail }}</div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import {
    entityTypeLabels,
    verificationLabel,
    vettingClassLabels,
    vettingStatusLabels,
} from '~/components/kiosk/kiosk-ten-dlc/tenDlcLabels';
import type { TcrEntityType, TcrVettingClass, TcrVettingStatus } from '~/services/adminTenDlcClient.types';

const props = defineProps<{
    verified: boolean | null;
    vettingScore: number | null;
    entityType: TcrEntityType | null;
    vettingClass: TcrVettingClass | null;
    vettingStatus: TcrVettingStatus | null;
}>();

const verificationDetail = computed(() => verificationLabel(props.verified, props.vettingScore));

const vettingDetail = computed(() => {
    if (null === props.vettingClass) {
        return '';
    }

    const base = `${vettingClassLabels[props.vettingClass]} vetting`;

    return null !== props.vettingStatus ? `${base} · ${vettingStatusLabels[props.vettingStatus]}` : base;
});
</script>
